import { render, staticRenderFns } from "./MapsWithFriends.vue?vue&type=template&id=bd5b6ae0&scoped=true&"
import script from "./MapsWithFriends.vue?vue&type=script&lang=ts&"
export * from "./MapsWithFriends.vue?vue&type=script&lang=ts&"
import style0 from "./MapsWithFriends.vue?vue&type=style&index=0&id=bd5b6ae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5b6ae0",
  null
  
)

export default component.exports